export default __webpack_public_path__ + "media/images/banners/bnr_imabari-0a4ad9e664e96fd8dccdaf9ae7f43335.png";